import { v4 as uuidv4 } from 'uuid';

const COOKIE_NAME = 'bubble_fid';
const STORAGE_KEY = 'bubble_fid';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, value, days = 3650) {
  const d = new Date();
  d.setTime(d.getTime() + days*24*60*60*1000);
  document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/; SameSite=Lax`;
}

export function getOrCreateDeviceId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY) || getCookie(COOKIE_NAME);
    if (!id) {
      id = uuidv4();
      localStorage.setItem(STORAGE_KEY, id);
      setCookie(COOKIE_NAME, id);
    } else {
      // ensure both storage and cookie have the same
      try { localStorage.setItem(STORAGE_KEY, id); } catch {}
      try { setCookie(COOKIE_NAME, id); } catch {}
    }
    return id;
  } catch (_) {
    // fallback if storage blocked
    const id = uuidv4();
    try { setCookie(COOKIE_NAME, id); } catch {}
    return id;
  }
}
